// extracted by mini-css-extract-plugin
module.exports = {"your-feed-preview__list":"your-feed-preview_your-feed-preview__list__7Irtw"};